var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9078 3.91255C20.6891 3.1313 20.6891 1.86255 19.9078 1.0813C19.1266 0.300049 17.8578 0.300049 17.0766 1.0813L10.4953 7.6688L3.90782 1.08755C3.12657 0.306299 1.85782 0.306299 1.07657 1.08755C0.295319 1.8688 0.295319 3.13755 1.07657 3.9188L7.66407 10.5L1.08282 17.0875C0.301569 17.8688 0.301569 19.1376 1.08282 19.9188C1.86407 20.7001 3.13282 20.7001 3.91407 19.9188L10.4953 13.3313L17.0828 19.9125C17.8641 20.6938 19.1328 20.6938 19.9141 19.9125C20.6953 19.1313 20.6953 17.8625 19.9141 17.0813L13.3266 10.5L19.9078 3.91255Z","fill":"#36373A"}));
}

Cross.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
